<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="Image of Understanding Postmodernism cover" class="cover" src="Images/9780830889082.jpg"/>
<p class="firstleft"><span epub:type="pagebreak" id="pagei" title="i"></span></p>
<p class="firstleft"><span epub:type="pagebreak" id="pageii" title="ii"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_cover.vue?238ce6c9